import { render, staticRenderFns } from "./PageTitleList.vue?vue&type=template&id=2070d719"
import script from "./PageTitleList.vue?vue&type=script&lang=ts"
export * from "./PageTitleList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports